var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187px",
    height: "140px",
    viewBox: "0 0 187 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Servicer_Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.1809918,0 C18.1809918,4.96154895 14.5120676,8.99918189 10.0004545,8.99918189 L10.0004545,8.99918189 C5.48975047,8.99918189 1.81809918,4.96154895 1.81809918,0 L1.81809918,0 L0,0 C0,6.06444869 4.48706877,11 10.0004545,11 L10.0004545,11 C15.5129312,11 20,6.06444869 20,0 L20,0 L18.1809918,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Servicer_Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.112421,105.462246 L101.468081,105.326307 L109.598271,109 L109.128821,99.8657413 L109.368315,99.5803336 C111.586891,96.9246132 113.081348,93.719259 113.689189,90.3107568 C115.611932,79.5288689 108.413338,69.229661 97.6420658,67.3517363 C92.372724,66.4330494 98.3176091,66.7595134 99.0564712,75.291213 C99.7953333,83.8229127 98.8488525,89.1303564 95.7273843,93.9592543 C90.4225015,102.165885 79.8968685,104.580486 90.668141,106.458411 C94.1753973,107.069886 97.7872076,106.725433 101.112421,105.462246 Z",
    id: "Fill-1-Copy",
    fill: "#C7E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.574512,106.532601 L109.221928,109.895102 C110.047526,110.258428 111.006229,109.631111 111.006229,108.733711 L111.006229,100.240816 C114.230451,96.4865597 116,91.7287989 116,86.7867522 C116,82.4349622 114.655204,78.2676275 112.111265,74.7350558 C111.154596,73.405455 109.088653,74.8873583 110.046,76.2164514 C112.277097,79.3147918 113.4564,82.9698825 113.4564,86.7867522 C113.4564,91.2652917 111.798762,95.5724062 108.788528,98.9145999 C108.57878,99.1476227 108.46263,99.4498585 108.46263,99.763094 L108.46263,106.787793 L102.146445,104.010641 C101.85022,103.880169 101.514996,103.867815 101.209785,103.975443 C99.2184483,104.678572 97.1291053,105.03496 94.9997457,105.03496 C84.8228037,105.03496 76.5432605,96.8488704 76.5432605,86.7867522 C76.5432605,76.724634 84.8229732,68.5383749 94.9999152,68.5383749 C98.795052,68.5383749 102.439787,69.6677825 105.540059,71.8045865 C106.889603,72.7346471 108.33495,70.6460722 106.985236,69.7158424 C103.458177,67.2849254 99.3135726,66 94.9999152,66 C83.4205259,66 74,75.3248049 74,86.786583 C74,98.2483611 83.4205259,107.573166 94.9999152,107.573166 C97.24729,107.573166 99.4563438,107.223378 101.574512,106.532601 Z",
    id: "Path",
    fill: "#0052CD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    transform: "translate(85.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#0057B8",
    mask: "url(#mask-2)",
    points: "-985 7420 233 7420 233 -1062 -985 -1062"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#0054C6",
    mask: "url(#mask-2)",
    points: "-4 17 26 17 26 -6 -4 -6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(55.000000, 10.000000)",
    fill: "#0057B8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.674,6.816 C5.147,6.816 4.718,7.244 4.718,7.772 L4.718,9.989 C4.718,10.517 5.147,10.944 5.674,10.944 C6.201,10.944 6.63,10.517 6.63,9.989 L6.63,7.772 C6.63,7.244 6.201,6.816 5.674,6.816",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.173,4.592 L0.955,4.592 C0.428,4.592 -4.26325641e-14,5.02 -4.26325641e-14,5.548 C-4.26325641e-14,6.076 0.428,6.504 0.955,6.504 L3.173,6.504 C3.7,6.504 4.128,6.076 4.128,5.548 C4.128,5.02 3.7,4.592 3.173,4.592",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.674,8.48210391e-14 C5.147,8.48210391e-14 4.718,0.427 4.718,0.955 L4.718,3.171 C4.718,3.699 5.147,4.127 5.674,4.127 C6.201,4.127 6.63,3.699 6.63,3.171 L6.63,0.955 C6.63,0.427 6.201,8.48210391e-14 5.674,8.48210391e-14",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,4.44 L8.175,4.44 C7.648,4.44 7.22,4.868 7.22,5.396 C7.22,5.924 7.648,6.352 8.175,6.352 L10.393,6.352 C10.921,6.352 11.349,5.924 11.349,5.396 C11.349,4.868 10.921,4.44 10.393,4.44",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(168.000000, 100.000000)",
    fill: "#0057B8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12 C8.67311715,12 8,12.7257752 8,13.621124 L8,17.3805717 C8,18.2759205 8.67311715,19 9.5,19 C10.3268828,19 11,18.2759205 11,17.3805717 L11,13.621124 C11,12.7257752 10.3268828,12 9.5,12",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38057171,8 L1.61942829,8 C0.725775194,8 0,8.67154812 0,9.5 C0,10.3284519 0.725775194,11 1.61942829,11 L5.38057171,11 C6.27422481,11 7,10.3284519 7,9.5 C7,8.67154812 6.27422481,8 5.38057171,8",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0 C8.67311715,0 8,0.724254907 8,1.61982069 L8,5.37848316 C8,6.27404895 8.67311715,7 9.5,7 C10.3268828,7 11,6.27404895 11,5.37848316 L11,1.61982069 C11,0.724254907 10.3268828,0 9.5,0",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3792686,8 L13.6190361,8 C12.7255994,8 12,8.67154812 12,9.5 C12,10.3284519 12.7255994,11 13.6190361,11 L17.3792686,11 C18.2744006,11 19,10.3284519 19,9.5 C19,8.67154812 18.2744006,8 17.3792686,8",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.569,109 C9.569,109 10.875,118.309 1.42108547e-13,118.094 C1.42108547e-13,118.094 9.341,118.19 9.096,126.926 C9.096,126.926 9.936,120.053 18.508,118.518 C18.508,118.518 11.264,120.18 9.569,109",
    id: "Fill-22-Copy",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.569,38 C158.569,38 159.874,47.309 149,47.094 C149,47.094 158.341,47.19 158.096,55.925 C158.096,55.925 158.935,49.053 167.507,47.518 C167.507,47.518 160.264,49.18 158.569,38",
    id: "Fill-23-Copy",
    fill: "#63ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.170476,122 C66.170476,122 66.8756146,127.193305 61,127.073361 C61,127.073361 66.0472794,127.126918 65.9148971,132 C65.9148971,132 66.368239,128.166248 71,127.309902 C71,127.309902 67.0863457,128.237099 66.170476,122",
    id: "Fill-23-Copy-2",
    fill: "#63ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.335,61 C27.335,61 27.79,64.244 24,64.17 C24,64.17 27.256,64.203 27.169,67.248 C27.169,67.248 27.462,64.853 30.45,64.317 C30.45,64.317 27.925,64.896 27.335,61",
    id: "Fill-24-Copy-4",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    stroke: "#0057B8",
    cx: 119,
    cy: 3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#005CC3",
    cx: 2.5,
    cy: 27.5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,129.518374 L98,140.481626 C98,142.423769 96.8262582,144 95.3741794,144 L92.2678337,144 C92.1785558,144 92.0866521,143.992963 92,143.982408 C93.3234136,143.799453 94.3553611,142.300625 94.3553611,140.481626 L94.3553611,129.518374 C94.3553611,127.699375 93.3234136,126.200547 92,126.017592 C92.0866521,126.007037 92.1785558,126 92.2678337,126 L95.3741794,126 C96.8262582,126 98,127.576231 98,129.518374 Z",
    id: "Path-Copy-15",
    fill: "#CCE3FD",
    fillRule: "nonzero",
    transform: "translate(95.000000, 135.000000) rotate(90.000000) translate(-95.000000, -135.000000) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    fill: "#C7E3FF",
    points: "135 70.6192423 135 105 139.730534 105 145.41846 105 149 100.013239 149 93.2255271 149 80.4549692 149 74.4616357 145.41846 70.6192423 139.730534 69 135 69"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6-Copy",
    fill: "#C7E3FF",
    transform: "translate(48.000000, 87.000000) scale(-1, 1) translate(-48.000000, -87.000000) ",
    points: "41 70.6192423 41 105 45.7305341 105 51.4184604 105 55 100.013239 55 93.2255271 55 80.4549692 55 74.4616357 51.4184604 70.6192423 45.7305341 69 41 69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.41291,67.7568555 C137.489219,45.695625 117.097109,30 94.9997852,30 C72.9022461,30 52.5109961,45.6960547 48.586875,67.7566406 C43.7281836,68.5150391 40,72.6986914 40,77.7314062 L40,83.0664062 C40,85.1445898 43.2226563,85.1445898 43.2226563,83.0664062 L43.2226563,77.7311914 C43.2226563,73.9400586 46.3402539,70.8557617 50.1724219,70.8557617 L53.5351563,70.8557617 L53.5351563,104.29168 L50.1724219,104.29168 C46.3402539,104.291895 43.2226563,101.207598 43.2226563,97.4166797 L43.2226563,91.2304688 C43.2226563,89.1522852 40,89.1522852 40,91.2304688 L40,97.4166797 C40,102.984785 44.5632813,107.514551 50.1724219,107.514551 L53.7070313,107.514551 C54.5000764,107.514551 56.9401237,107.396602 56.9401237,106.208945 L56.9401237,68.9389258 C56.7649903,67.6333203 54.2219306,67.6333203 53.7070313,67.6333203 L51.8898828,67.6333203 C55.8475195,47.4203906 74.6949023,33.2226562 94.9997852,33.2226562 C115.304668,33.2226562 134.152266,47.4201758 138.109902,67.6333203 L136.292969,67.6333203 C134.06596,67.6333203 132.603587,67.7055078 132.603587,68.9389258 L132.603587,106.208945 C132.983806,108.21917 136.292969,107.514551 136.292969,107.514551 L138.088633,107.514551 C135.197051,122.826895 121.200195,132.80875 105.990117,133.29043 C105.305195,131.286797 103.395449,129.840684 101.150977,129.840684 L88.8490234,129.840684 C86.080332,129.840684 83.73875,132.142734 83.73875,134.920449 C83.73875,137.698164 86.080332,140 88.8490234,140 L101.150977,140 C103.408984,140 105.328398,138.53627 106.002578,136.51373 C123.044199,136.011426 138.488242,124.562617 141.382402,107.396602 C146.255918,106.651309 150,102.459922 150,97.4166797 L150,77.7314062 C150,72.6986914 146.271602,68.5150391 141.41291,67.7568555 Z M101.172485,136 L88.8273533,136 C86.3917447,136 86.3900199,133 88.8273533,133 L101.172485,133 C103.608309,133 103.610034,136 101.172485,136 Z M146,97.2144202 C146,100.956126 142.976667,104 139.260417,104 L136,104 L136,71 L139.260417,71 C142.976667,71 146,74.0440856 146,77.7857919 L146,97.2144202 Z",
    id: "Shape",
    stroke: "#0056BF",
    strokeWidth: 0.7,
    fill: "#0056BF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicerIcon);
export default __webpack_public_path__ + "static/media/Servicer_Icon.b285393225f8b02f0c8afd2495f48770.svg";
export { ForwardRef as ReactComponent };